import React from 'react';
import { ArrowRight, ShieldCheck, CalendarCheck } from 'lucide-react';
import { Reveal } from './Reveal';
import { heroFaces } from '../data/mock';
import { BOOKING_URL, CTA_LABEL } from '../data/constants';

const CTASection = () => (
  <section className="relative bg-obsidian text-white py-28 lg:py-36 overflow-hidden grain" data-testid="cta-section">
    <div className="absolute inset-0 mesh-grid" />
    <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[600px] rounded-full bg-violet-700/30 blur-[160px] light-pool" />
    <div className="absolute right-0 bottom-0 w-[400px] h-[400px] rounded-full bg-amber-500/15 blur-[120px]" />
    <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-amber-400/50 to-transparent" />

    <div className="relative z-10 max-w-4xl mx-auto px-5 lg:px-8 text-center">
      <Reveal>
        <span className="inline-flex items-center gap-2 rounded-full border border-amber-400/30 bg-amber-400/10 px-4 py-2 text-xs font-semibold tracking-[0.18em] uppercase text-amber-300">
          <ShieldCheck className="w-4 h-4" /> 100 % Nachbesetzungs-Garantie
        </span>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-8 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.02]">
          Deine nächste Position.<br /><span className="text-gold">Besetzt in 24 Stunden.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.2}>
        <p className="mt-7 text-base md:text-lg text-slate-300 max-w-2xl mx-auto leading-relaxed">
          30 Minuten Erstgespräch. Danach weißt du genau, ob und wie HIREKA deine Stelle besetzt – kostenlos und unverbindlich.
        </p>
      </Reveal>
      <Reveal delay={0.3} className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
        <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="btn-gold px-9 py-5 text-base sm:text-lg w-full sm:w-auto" data-testid="cta-main-btn">
          <CalendarCheck className="w-5 h-5" /> {CTA_LABEL} <ArrowRight className="w-5 h-5" />
        </a>
      </Reveal>
      <Reveal delay={0.4} className="mt-10 flex items-center justify-center gap-3">
        <div className="flex -space-x-2.5">
          {heroFaces.map((src, i) => <img key={i} src={src} alt="" className="w-9 h-9 rounded-full object-cover border-2 border-[#0B0A12]" />)}
        </div>
        <p className="text-sm text-slate-400">Diese Woche bereits <span className="text-white font-semibold">7 Erstgespräche</span> gebucht</p>
      </Reveal>
    </div>
  </section>
);

export default CTASection;
